import Regime from 'modules/contracts/store/models/Regime'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

export interface IRegime {
  id: number
  legal_entity_id: number
  name: string
}

class Regimes extends PayrollLegalEntityResource<Regime> {
  get cacheKey(): string {
    return 'regimes'
  }

  model() {
    return Regime
  }
}

export { Regimes }
